import PaymentSuccessfulModal from './PaymentSuccessfulModal';

export default PaymentSuccessfulModal;
